import loadTracking from 'common/module/tracking-loader';
import initJan from 'common/tracking/jan';

import initSignInForm from 'userspace/containers/sign-in';
import pageCommon from 'userspace/page-common';

pageCommon().then(() => {
  initSignInForm();

  loadTracking(false);
  initJan();
});
